enum ReservationConfirmationResult {
  successful = 'successful',
  tokenInvalid = 'tokenInvalid',
  tokenExpired = 'tokenExpired',
  reservationNotPending = 'reservationNotPending',
  failed = 'failed',
}

export default ReservationConfirmationResult;
